const i18n = {
	title: {
		de: 'Erbrechner',
		fr: 'Calculateur pour la répartition de la succession'
	},
	defaultDistribution: {
		de: 'Deine persönliche Situation und Standard-Erbverteilung',
		fr: 'Ta situation personnelle et la répartition standard de l’héritage'
	},
	defaultDistributionHint: {
		de: 'Beantworte die folgenden Fragen, um basierend auf deinen Familienverhältnissen die Standard-Erbverteilung auszurechnen.<br><br>Du wirst nur nach den rechtlich relevanten Familienmitgliedern gefragt. Verstorbene sind für die Erbverteilung nur relevant, wenn sie lebende Nachkommen hinterlassen haben.<br><br>Im nachfolgenden Schritt kannst du die Verteilung deines Nachlasses dann nach deinen Wünschen anpassen.',
		fr: 'Réponds aux questions suivantes pour calculer la répartition standard de l’héritage sur la base de ta situation familiale.<br><br>Tu ne seras interrogé(e) que sur les membres de la famille juridiquement concernés. Les personnes décédées ne sont pertinentes pour la répartition de l’héritage que si elles ont laissé des descendants vivants.<br><br>Dans l’étape suivante, tu peux ensuite adapter la répartition de ton héritage selon tes souhaits.'
	},
	spouse: {
		de: 'Ehepartner/in oder eingetragene/r Lebenspartner/in',
		fr: 'Conjoint(e) ou partenaire enregistré(e)'
	},
	spousePresent: {
		de: 'Hast du eine/n Ehepartner/in oder eingetragene/r Lebenspartner/in?',
		fr: 'As-tu un(e) conjoint(e) ou un(e) partenaire enregistré(e)?'
	},
	firstParentela: {
		de: 'Kinder/Enkel und deren Nachkommen',
		fr: 'Enfants/petits-enfants et leurs descendants'
	},
	firstParentelaPresent: {
		de: 'Hast du lebende Kinder/Enkel oder deren Nachkommen?',
		fr: 'As-tu des enfants/petits-enfants vivants ou leurs descendants?'
	},
	firstParentela1: { de: 'Kind', fr: 'Enfant' },
	firstParentela2: { de: 'Enkel/in', fr: 'Petit-fils/petite-fille' },
	firstParentela3: { de: 'Urenkel/in', fr: 'Arrière-petit-fils/petite-fille' },
	firstParentela4: { de: 'Ururenkel/in', fr: 'Arrière-arrière-petit-fils/petite-fille' },
	firstParentela5: {
		de: 'Nachkomme von Ururenkel/in',
		fr: 'Descendant(e) d’arrière-arrière-petit-fils/petite-fille'
	},
	secondParentela: {
		de: 'Eltern/Geschwister/Nichten/Neffen und deren Nachkommen',
		fr: 'Parents/frères et sœurs/nièces/neveux et leurs descendants'
	},
	secondParentelaPresent: {
		de: 'Hast du lebende Eltern/Geschwister/Nichten/Neffen oder deren Nachkommen?',
		fr: 'As-tu des parents/frères et sœurs/nièces/neveux vivants ou leurs descendants?'
	},
	secondParentela1Mother: { de: 'Mutter', fr: 'Mère' },
	secondParentela1Father: { de: 'Vater', fr: 'Père' },
	secondParentela1Combined: { de: 'Eltern', fr: 'Parents' },
	secondParentela2: { de: 'Geschwister', fr: 'Frères et sœurs' },
	secondParentela3: { de: 'Nichte/Neffe', fr: 'Nièce/neveu' },
	secondParentela4: { de: 'Grossnichte/Grossneffe', fr: 'Petite-nièce/petit-neveu' },
	secondParentela5: {
		de: 'Nachkomme von Grossnichte/Grossneffe',
		fr: 'Descendant de petite-nièce/petit-neveu'
	},
	thirdParentela: {
		de: 'Weitere Verwandte wie Grosseltern, Tanten/Onkel, Cousinen/Cousins und deren Nachkommen',
		fr: 'Autres parents tels que grands-parents, tantes/oncles, cousins/cousines et leurs descendants'
	},
	thirdParentelaPresent: {
		de: 'Hast du weitere lebende Verwandte wie Grosseltern, Tanten/Onkel, Cousinen/Cousins oder deren Nachkommen?',
		fr: 'As-tu d’autres parents vivants, comme des grands-parents, des oncles/tantes, des cousins/cousines ou leurs descendants?'
	},
	thirdParentela1Branch1: { de: 'Stamm mütterlicherseits', fr: 'Du côté paternel' },
	thirdParentela1Branch2: { de: 'Stamm mütterlicherseits', fr: 'Du côté maternel' },
	thirdParentela2Grandmother1: { de: 'Grossmutter', fr: 'Grand-mère' },
	thirdParentela2Grandfather1: { de: 'Grossvater', fr: 'Grand-père' },
	thirdParentela2Grandmother2: { de: 'Grossmutter', fr: 'Grand-mère' },
	thirdParentela2Grandfather2: { de: 'Grossvater', fr: 'Grand-père' },
	thirdParentela2Combined: { de: 'Grosseltern', fr: 'Grands-parents' },
	thirdParentela3: { de: 'Tante/Onkel', fr: 'Tante/oncle' },
	thirdParentela4: { de: 'Cousine/Cousin', fr: 'Cousine/cousin' },
	thirdParentela5: {
		de: 'Nachkomme von Cousine/Cousin',
		fr: 'Descendant de cousin/cousine'
	},
	deceasedHint: {
		de: 'Verstorbene sind für die Erbverteilung nur relevant, wenn sie lebende Nachkommen hinterlassen. Ist das nicht der Fall, muss die verstorbene Person entfernt werden.',
		fr: 'Les personnes décédées ne sont pertinentes pour la répartition de l’héritage que si elles laissent des descendants vivants. Si ce n’est pas le cas, la personne décédée doit être retirée.'
	},
	custom: {
		de: 'Weitere Erben oder Vermächtnisnehmer',
		fr: 'Autres héritiers ou légataires'
	},
	customHint: {
		de: 'Bei Vermächtnisnehmern hast du die Möglichkeit, entweder einen Fixbetrag oder eine Quote am Nachlass zu wählen. Ein Fixbetrag wird im Kuchendiagramm nicht berücksichtigt.',
		fr: 'Pour les légataires, tu as la possibilité de choisir soit un montant fixe, soit une quote-part de la succession. Un montant fixe n’est pas pris en compte dans le camembert.'
	},
	customPresent: {
		de: 'Möchtest du weitere Erben oder Vermächtnisnehmer einfügen?',
		fr: 'Souhaites-tu ajouter d’autres héritiers ou légataires?'
	},
	customPresentHint: {
		de: 'Wenn du neben den erbberechtigten Familienmitgliedern weitere Personen (z.B. Konkubinatspartner/in, Lebensgefährte/in oder Patenkind) oder Organisationen (z.B. Stiftungen oder andere gemeinnützige Organisationen) begünstigen möchtest, kannst du das hier tun. Standardmässig werden sie als sogenannte Vermächtnisnehmer und nicht als Erben eingefügt. Sie haben keinen gesetzlichen Erbteil oder Pflichtteil.',
		fr: 'Si, en plus des membres de la famille ayant droit à l’héritage, tu souhaites favoriser d’autres personnes (p. ex. concubin(e), compagnon/compagne ou filleul(e)) ou organisations (p. ex. fondations ou autres organisations d’utilité publique), tu peux le faire ici. Par défaut, ils sont insérés en tant que dits légataires et non en tant qu’héritiers. Ils n’ont pas de part légale d’héritage ou de réserve.'
	},
	customPresentHintExtended: {
		de: '<em>Wann ist ein Vermächtnis sinnvoll?</em><br>Mit einem Vermächtnis kannst du jemanden begünstigen, der nicht erbberechtigt ist, beispielsweise eine dir nahestehende Person oder eine gemeinnützige Organisation. Du solltest in deinem Testament klar unterscheiden, ob einer Person oder Organisation ein Vermächtnis zukommen oder diese als Erbe eingesetzt werden soll. Wer ein Vermächtnis erhält, gehört nicht zur Gemeinschaft der Erben, hat aber Anspruch auf die Herausgabe des Vermächtnisses. Oft wird ein Geldbetrag gespendet, manchmal sind es auch Wertgegenstände oder Liegenschaften.<br><br>Ebenso ist es wichtig, dass die Pflichtteile deiner gesetzlichen Erben nicht durch von dir festgelegte Vermächtnisse verletzt werden, sonst werden diese allenfalls entsprechend gekürzt.<br><br><em>Wen kann ich als Vermächtnisnehmer einsetzen?</em><br>Als Vermächtnisnehmer kannst du jede natürliche oder juristische Person einsetzen. Das heisst, dass du neben Privatpersonen auch Genossenschaften, Vereine, Stiftungen aber auch Kapitalgesellschaften (Aktiengesellschaften, Gesellschaften mit beschränkter Haftung) als Vermächtnisnehmer einsetzen kannst. Wichtig ist, dass du den Vermächtnisnehmer genau bestimmst. Ein genereller Hinweis auf eine bestimmte Gruppe von Personen oder Organisationen reicht in der Regel nicht.<br><br><em>Wen kann ich als Erben einsetzen?</em><br>Als Erben kannst du jede natürliche oder juristische Person einsetzen. Das heisst, dass du neben Privatpersonen auch Genossenschaften, Vereine, Stiftungen aber auch Kapitalgesellschaften (Aktiengesellschaften, Gesellschaften mit beschränkter Haftung) als Erben einsetzen kannst. Ferner kannst du auch ein bereits gezeugtes, aber noch ungeborenes Kind kann als Erbe einsetzen. Das ungeborene Kind wird jedoch nur Erbe, wenn es zum Zeitpunkt des Erbganges erbfähig bzw. lebend geboren worden ist.',
		fr: '<em>Quand un legs est-il utile?</em><br>Un legs te permet de favoriser quelqu’un qui n’a pas droit à l’héritage, par exemple une personne qui t’est proche ou une organisation d’utilité publique. Tu dois clairement distinguer dans ton testament si une personne ou une organisation doit recevoir un legs ou si elle doit être désignée comme héritière. Celui qui reçoit un legs ne fait pas partie de la communauté des héritiers, mais il a droit à la restitution du legs. Il s’agit souvent d’une somme d’argent, mais parfois aussi d’objets de valeur ou de biens immobiliers.<br><br>De même, il est important que les parts réservataires de tes héritiers légaux ne soient pas lésées par les legs que tu as fixés, sinon ceux-ci seront éventuellement réduits en conséquence.<br><br><em>Qui puis-je désigner comme légataire? </em><br>Toute personne physique ou morale peut être désignée comme légataire. Cela signifie que tu peux désigner comme légataires non seulement des personnes privées, mais aussi des coopératives, des associations, des fondations, mais aussi des sociétés de capitaux (sociétés anonymes, sociétés à responsabilité limitée). Il est important que tu désignes précisément le légataire. Une référence générale à un groupe particulier de personnes ou d’organisations ne suffit généralement pas.<br><br><em>Qui puis-je désigner comme héritier?</em><br>Toute personne physique ou morale peut être désignée comme héritier. Cela signifie que tu peux désigner comme héritiers non seulement des personnes privées, mais aussi des coopératives, des associations, des fondations, mais aussi des sociétés de capitaux (sociétés anonymes, sociétés à responsabilité limitée). En outre, tu peux également désigner comme héritier un enfant déjà conçu mais pas encore né. L’enfant à naître ne devient toutefois héritier que s’il est apte à hériter ou s’il est né vivant au moment de la dévolution successorale.'
	},
	statutoryShares: { de: 'Gesetzliche Erbteile', fr: 'Parts légales de la succession' },
	compulsoryShares: {
		de: 'Pflichtteile und frei verfügbare Quote',
		fr: 'Réserves légales et quotité disponible'
	},
	government: { de: 'Kanton / Gemeinde', fr: 'Canton / commune' },
	free: { de: 'Freie Quote', fr: 'Quota libre' },
	addPerson: { de: 'Nachkomme hinzufügen', fr: 'Ajouter un descendant' },
	addPersonFirstParentela1: { de: 'Kind hinzufügen', fr: 'Ajouter un enfant' },
	addPersonFirstParentela2: {
		de: 'Enkel/in hinzufügen',
		fr: 'Ajouter un petit-fils/une petite-fille'
	},
	addPersonFirstParentela3: {
		de: 'Urenkel/in hinzufügen',
		fr: 'Ajouter un(e) arrière-petit-fils/petite-fille'
	},
	addPersonFirstParentela4: {
		de: 'Ururenkel/in hinzufügen',
		fr: 'Ajouter un(e) arrière-arrière-petit-fils/petite-fille'
	},
	addPersonSecondParentela2: { de: 'Geschwister hinzufügen', fr: 'Ajouter des frères et sœurs' },
	addPersonSecondParentela3: { de: 'Nichte/Neffe hinzufügen', fr: 'Ajouter une nièce/un neveu' },
	addPersonSecondParentela4: {
		de: 'Grossnichte/Grossneffe hinzufügen',
		fr: 'Ajouter une petite-nièce/un petit-neveu'
	},
	addPersonSecondParentela5: {
		de: 'Nachkomme von Grossnichte/Grossneffe hinzufügen',
		fr: 'Ajouter un descendant de petite-nièce/petit-neveu'
	},
	addPersonThirdParentela3: { de: 'Tante/Onkel hinzufügen', fr: 'Ajouter une tante/un oncle' },
	addPersonThirdParentela4: {
		de: 'Cousine/Cousin hinzufügen',
		fr: 'Ajouter un cousin/une cousine'
	},
	addPersonThirdParentela5: {
		de: 'Nachkomme von Cousine/Cousin hinzufügen',
		fr: 'Ajouter un descendant de cousin/cousine'
	},
	addPersonCustom1: {
		de: 'Person/Organisation hinzufügen',
		fr: 'Ajouter une personne/organisation'
	},
	removePerson: { de: 'Person entfernen', fr: 'Supprimer une personne' },
	customDistribution: {
		de: 'Eigene Erbverteilung',
		fr: 'Propre répartition de l’héritage'
	},
	customDistributionHint: {
		de: 'Gestalte nun eine Erbverteilung nach deinem Wunsch. Bei erbberechtigten pflichtteilsgeschützten Personen kannst du den gesetzlichen Pflichtteil mit unserem Erbplaner nicht unterschreiten.',
		fr: 'Crée maintenant une répartition de l’héritage selon tes souhaits. Pour les personnes protégées par une réserve héréditaire, tu ne peux pas descendre en dessous de la réserve légale avec notre planificateur successoral.'
	},
	customizeTitle: {
		de: 'Eigene Erbverteilung',
		fr: 'Propre répartition de l’héritage'
	},
	customizeShareLegatee: { de: 'Vermächtnis', fr: 'Legs' },
	customizeShareLegateeHint: {
		de: 'Wenn du jemanden als Vermächtnisnehmer einsetzt, hat diese Person oder Organisation lediglich Anspruch auf die Herausgabe des ihr vermachten Betrages oder Vermögenswerts. Hingegen wird sie nicht Mitglied der Erbengemeinschaft und hat damit kein Mitspracherecht bei der Verteilung deines Nachlasses.',
		fr: 'Si tu désignes quelqu’un comme légataire, cette personne ou organisation n’a droit qu’à la remise de la somme ou du bien qui lui a été légué. En revanche, elle ne devient pas membre de la communauté héréditaire et n’a donc pas de droit de regard sur la répartition de ta succession.'
	},
	customizeShareHeir: { de: 'Erbe', fr: 'Héritage' },
	customizeShareHeirHint: {
		de: 'Wenn du jemanden als Erben einsetzt, wird diese Person oder Organisation Mitglied der Erbengemeinschaft und hat umfassende Rechte und Pflichten im Rahmen deiner Nachlassabwicklung.',
		fr: 'Si tu désignes quelqu’un comme héritier, cette personne ou organisation devient membre de la communauté héréditaire et dispose de droits et d’obligations étendus dans le cadre du règlement de ta succession.'
	},
	customizeValue: { de: 'Prozentualer Anteil', fr: 'Pourcentage' },
	customizeFix: { de: 'Wert fixieren', fr: 'Fixer la valeur' },
	customizeAbsoluteValue: { de: 'Betrag (CHF)', fr: 'Montant (CHF)' },
	customizeRelativeShare: { de: '%', fr: '%' },
	customizeRelativeShareHint: {
		de: 'Sofern du dem Vermächtnisnehmer eine Quote an deinem Netto-Nachlass vermachen möchtest, kannst du hier den prozentualen Umfang dieser Quote festlegen. Bei Vorhandensein von erbberechtigten pflichtteilsgeschützten Personen kannst du deren gesetzliche Pflichtteile nicht unterschreiten.',
		fr: 'Si tu souhaites léguer au légataire une quote-part de ta succession nette, tu peux fixer ici le pourcentage de cette quote-part. En présence de personnes protégées par des réserves héréditaires, tu ne peux pas descendre en dessous de leurs réserves légales.'
	},
	customizeAbsoluteShare: { de: 'CHF', fr: 'CHF' },
	customizeAbsoluteShareHint: {
		de: 'Lege einen bestimmten Betrag fest, welchen der Vermächtnisnehmer aus deinem Nachlass erhalten soll. Falls durch den von dir festgelegten Betrag die Ansprüche von erbberechtigten pflichtteilsgeschützten Personen verletzt werden sollten, besteht die Gefahr, dass dieser Betrag herabgesetzt wird.',
		fr: 'Fixe un montant précis que le légataire doit recevoir de ta succession. Si le montant que tu as fixé porte atteinte aux droits des personnes réservataires protégées par des réserves héréditaires, ce montant risque d’être réduit.'
	},
	customizeValueCompulsory: { de: 'Pflicht', fr: 'Obligatoire' },
	formSubmit: { de: 'Absenden', fr: 'Envoyer' },
	validationError: {
		de: 'Die freie Quote muss 0 sein. Bitte erhöhe die Quoten von Familienmitgliedern oder füge einen Vermächtnisnehmer mit Quote hinzu.',
		fr: 'La quote-part libre doit être égale à 0. Veuillez augmenter les quotes-parts des membres de la famille ou ajouter un légataire avec quote-part.'
	},
	yes: { de: 'Ja', fr: 'Oui' },
	no: { de: 'Nein', fr: 'Non' },
	name: { de: 'Name', fr: 'Nom' },
	nameHint: {
		de: 'Bitte Name angeben und auswählen, ob die Person verstorben ist.',
		fr: 'Veuillez indiquer le nom et choisir si la personne est décédée.'
	},
	deceased: { de: 'verstorben', fr: 'Décédé(e)' },
	goToCustomizer: {
		de: 'Weiter zu eigener Verteilung',
		fr: 'Continuer à distribuer soi-même'
	},
	goToConfigurator: {
		de: 'Zurück zu persönlicher Situation',
		fr: 'Retour à la situation personnelle'
	},
	goToWill: { de: 'Testament erstellen', fr: 'Rédiger un testament' },
	reset: { de: 'Zurücksetzen', fr: 'Réinitialiser' },
	showMore: { de: 'Weitere Informationen', fr: 'Plus d’informations' }
};

const configurator = [
	{
		key: 'spouse',
		isChecked: undefined
	},
	{
		key: 'firstParentela',
		isChecked: undefined,
		parts: [{ key: 'firstParentela-item1' }],
		showAdd: true
	},
	{
		key: 'secondParentela',
		isChecked: undefined,
		parts: [
			{
				key: 'mother'
			},
			{
				key: 'father'
			}
		]
	},
	{
		key: 'thirdParentela',
		isChecked: undefined,
		parts: [
			{
				key: 'branch1',
				isPlaceholder: true,
				parts: [
					{
						key: 'grandmother1'
					},
					{
						key: 'grandfather1'
					}
				]
			},
			{
				key: 'branch2',
				isPlaceholder: true,
				parts: [
					{
						key: 'grandmother2'
					},
					{
						key: 'grandfather2'
					}
				]
			}
		]
	},
	{
		key: 'custom',
		isChecked: undefined,
		parts: [{ key: 'custom-item1', isLegatee: true, isAbsolute: true }],
		showAdd: true
	}
];

const VIEWS = {
	CONFIGURATOR: 'configurator',
	CUSTOMIZER: 'customizer',
	SUMMARY: 'summary'
};

module.exports = {
	i18n,
	configurator,
	VIEWS
};
